import {apiRequest} from "../helpers/utils";

export const cloakingDomainServices = {
    read,
    find,
    remove,
    addAndVerify
};

function read(name) {
    let params = {
        name,
        isDeleted: false,
        pageSize: 250
    };
    return apiRequest("get", "v1/cloaking-domain", {}, params);
}

function find(id) {
    return apiRequest("get", "v1/cloaking-domain/" + parseInt(id));
}

function addAndVerify(domain) {
    return apiRequest("post", "v1/cloaking-domain", {domain});
}

function remove(id) {
    return apiRequest("delete", "v1/cloaking-domain/" + parseInt(id));
}